import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfileService } from '../../_core/services/profile.service';
import { ExtraOption } from '../../_core/models/extra-option.model';
import { ChosenExtraOptionService } from '../../_core/services/chosen-elements/chosen-extra-option.service';
import { Subscription } from 'rxjs';
import { ToolboxItemService } from 'src/app/_core/services/toolbox-item.service';
import { ProjectService } from 'src/app/_core/services/project.service';
import { ExtraOptionService } from 'src/app/_core/services/extra-option.service';
import { ToolboxItem } from 'src/app/_core/models/ToolboxModel';
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
	selector: 'app-extras-options',
	templateUrl: './extras-options.component.html',
	styleUrls: ['./extras-options.component.css', './../../../assets/styles/svg-component.css']
})
export class ExtrasOptionsComponent implements OnInit, OnDestroy {

	chosenOption: ExtraOption = null;
	subscription = new Subscription();
	public currentTool: ToolboxItem;
	public isHover : boolean = false;

	public selectedKeys: number[] = [];

	constructor(
		public profileService: ProfileService,
		private chosenExtraOptionService: ChosenExtraOptionService,
		private extraService: ExtraOptionService,
		public projectService: ProjectService,
		private toolBSrvc: ToolboxItemService,
	) { }

	ngOnInit(): void {
		this.subscription = this.chosenExtraOptionService.choseOptionSubj.subscribe((option: ExtraOption | null) => {
			this.chosenOption = option;
		})
		this.toolBSrvc.currentTool$.subscribe((ct: ToolboxItem) => {
			this.currentTool = ct;
		}); 
	} 

	choseOption(event: SelectionEvent) {
		if (event.selectedRows.length == 1){
			this.chosenExtraOptionService.setChosenOption(event.selectedRows[0].dataItem);
		} else {
			this.chosenExtraOptionService.setChosenOption(null);
		}
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	get nameColumnTitle(): string {
		return $localize`:Option list|'Option name' column title:Option name`;
	}

	get quantityColumnTitle(): string {
		return $localize`:Option list|'Quantity' column title:Quantity`;
	}

}
